
<div>
    <div #container></div>
    <mat-action-row *ngIf="!isLoadFromFile; else loadFromFile">
        <button mat-button (click)="isLoadFromFile = !isLoadFromFile">Extract Rule From File</button> 
        <button mat-button (click)="evaluateRule()">Validate</button>    
        <button mat-button *ngIf="!isModal" (click)="updateRule()">Update Rule</button>    
        <button mat-button *ngIf="isModal" (click)="saveNewRuleInGroup()">Save</button>
        <button mat-button *ngIf="!isModal" (click)="deleteRule()">Delete</button>
        <button mat-button *ngIf="!isModal" (click)="cancel()">Cancel</button>
        <button mat-button *ngIf="isModal" (click)="clear()">Clear</button>
    </mat-action-row>    
    <ng-template #loadFromFile>
        <mat-action-row >
            <input type="file" class="file-upload" accept=".config" (change)="ruleFileSelected($event)">
            <button mat-button (click)="isLoadFromFile = !isLoadFromFile">Cancel</button> 
        </mat-action-row>
    </ng-template>    

</div>
